import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { Icon } from "src/app/shared/components/utils/icon/icon";

@Component({
  selector: "app-error-page",
  imports: [TranslocoModule, Icon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex items-center justify-center min-h-screen">
      <div class="bg-vinciGrey-100 rounded-2xl p-10 m-10 min-h-[37.5rem]">
        <h2 class="pb-[2.5rem] flex items-center gap-4" id="error-page">
          <icon [name]="'danger'" [size]="'2.25rem'"></icon>
          {{ "error.title" | transloco }}
        </h2>
        <div
          class="mb-10 flex flex-col md:flex-row md:items-center justify-between gap-4"
        >
          <img
            class="max-w-[25rem] max-h-[25rem] rounded-full"
            src="assets/images/maintenance.svg"
            alt="Maintenance"
          />
          <p>{{ "error.text" | transloco }}</p>
        </div>
      </div>
    </div>
  `,
})
export class ErrorPage {}
